import React from 'react'
import { Navbar, Footer } from "../../components"
import ElecContent from './eleccontent/ElecContent'
import ElecHeader from './elecheader/ElecHeader'
import ElecUses from './elecuses/ElecUses'
import { Newsbar } from '../../components';

export default function Elec() {
  return (
    <div className='emas__elec'>
      <Navbar />
      <ElecHeader />
      <ElecContent />
      <ElecUses />
      <Newsbar />
      <Footer />
    </div>
  )
}
